import { getStoredEmployee } from "./panelSession";

function getEmployee() {
  return getStoredEmployee() || {};
}

export function isStrictWalletAdmin() {
  const emp = getEmployee();
  const role = String(emp?.role || "").toLowerCase();
  return role === "super_admin" || role === "admin";
}

export function canViewWalletModule() {
  return isStrictWalletAdmin();
}

export function canMutateWallet() {
  return isStrictWalletAdmin();
}
